import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTheme } from "../../../themes/theming";
import '../index.css';
import ProgressBarChart from "../../dashboard/widgets/progressChart";
import FilterDropdown from "../widgets/filterComponent"
import { fetchAvgScorePerChapter } from "../../../actions/dashboardAction";
import { AUTO_DEFAULT_FILTER } from "../../../AppConstant";

const AverageScoreChapter = (props) => {
    var I18n = require("react-redux-i18n").I18n;
    const { dispatch, dealerOperations } = props;
    const [data, setData] = useState([]);
    const [filterStatus, setFilterStatus] = useState(I18n.t('dashboardElements.AllAudit'))
    const [hasFetched, setHasFetched] = useState(false);

    const handleApplyFilters = (filters) => {
        setFilterStatus(filters[0]);
    };

    /** Memoize filtered data for performance and sorting */
    const filteredData = useMemo(() => {
        if (!data) return [];

        return data.map(item => {
            const firstAudit = item.firstAuditScore || {};
            const reAudit = item.reauditScore || {};

            const isFirstAudit = filterStatus === I18n.t('dashboardElements.FirstAudit');
            const isReaudit = filterStatus === I18n.t('dashboardElements.ReAudit');
            const isAllAudit = filterStatus === I18n.t('dashboardElements.AllAudit');

            if (isFirstAudit) {
                // For 1st Audit only - return simple value structure
                return {
                    nmscCode: item.chapterName,
                    value: parseFloat(firstAudit.overallScore) || 0,
                    reauditScore: parseFloat(firstAudit.criticalScore) || 0,
                    chapterId: item.chapterId || 0
                };
            } else if (isReaudit) {
                // For Re-Audit only - return simple value structure
                return {
                    nmscCode: item.chapterName,
                    value: parseFloat(reAudit.overallScore) || 0,
                    reauditScore: parseFloat(reAudit.criticalScore) || 0,
                    chapterId: item.chapterId || 0
                };
            } else {
                // For All Audit - return simple value structure using overAllAuditScore
                return {
                    nmscCode: item.chapterName,
                    value: parseFloat(item.overAllAuditScore) || 0,
                    reauditScore: parseFloat(item.criticalAuditScore) || 0,
                    chapterId: item.chapterId || 0
                };
            }
        }).sort((a, b) => {
            // Sort by chapterId in descending order
            const chapterIdA = a.chapterId || 0;
            const chapterIdB = b.chapterId || 0;
            return chapterIdB - chapterIdA;
        });
    }, [data, filterStatus]);

    /** Handler for API success callback */
    const onSuccess = (response) => setData(response);;
    /** Handler for API failure callback */
    const onFailure = (error) => console.error("❌ Error while fetching list of video", error);

    const fetchProgressBarData = () => {
        try {
            if (!props.toolboxByType?.toolboxByType || props.toolboxByType.toolboxByType?.length === 0) {
                return;
            }

            const toolBoxList = props.toolboxByType?.toolboxByType;
            const cycleList = props.cycleDataList;

            if (!toolBoxList || toolBoxList.length === 0 || !cycleList || cycleList.length === 0) {
                console.warn("Required data is not ready yet.");
                return;
            }

            const initialToolBoxId = toolBoxList[toolBoxList.length - 1];
            const initialCycle = cycleList[cycleList.length - 1];

            if (!initialCycle?.cycle) {
                console.warn("Initial cycle format is missing.");
                return;
            }
            const [initialStartDate, initialEndDate] = initialCycle.cycle.split(" to ");
            const nmscCode = props.existingProps.userMdl.nmsc;
            const activeProgram = props.existingProps.userMdl.activeProgram;

            const data = {
                "userNmscCode": props.existingProps.userMdl.nmsc,
                "userLangCode": props.existingProps.userMdl.lang,
                "programList": [props.existingProps.userMdl.activeProgram],
                "nmscCode": props.existingProps.nmscFlag ? [nmscCode.toUpperCase()] : props.existingProps.nmscFilter,
                "brand": props.existingProps.brandFilter,
                "country": props.existingProps.countryFilter,
                "region": props.existingProps.regionFilter,
                "userId": props.existingProps.userMdl.username,
                "businessArea": props.existingProps.userMdl.businessAreaKey,
                "toolboxIDList": (props.existingProps.toolboxIDList?.length > 0) ? props.existingProps.toolboxIDList : [Number(initialToolBoxId?.packageMapPrimaryKey)],
                "startDate": props.existingProps.startDate !== "" ? props.existingProps.startDate : initialStartDate,
                "endDate": props.existingProps.endDate !== "" ? props.existingProps.endDate : initialEndDate,
                "dealerOperations": dealerOperations?.length > 0 ? dealerOperations : (AUTO_DEFAULT_FILTER[activeProgram] || ['All'])
            }
            dispatch(fetchAvgScorePerChapter(onSuccess, onFailure, data))

        } catch (error) {
            console.error("Error fetching progress bar data:", error);
        }
    }


    useEffect(() => {
        const toolBoxReady = props.toolboxByType?.toolboxByType?.length > 0;
        const cycleReady = props.cycleDataList?.length > 0;

        if (toolBoxReady && cycleReady && !hasFetched) {
            fetchProgressBarData();
            setHasFetched(true);
        }
    }, [props.toolboxByType?.toolboxByType, props.cycleDataList, hasFetched]);

    return (
        <div className='toolboxImplNasCss'>
            <div className={"large-widget-header left-align-header widget-header-" + props.theme.name} title={I18n.t('dashboardHeaders.AverageResultPerChapterElement')}>
                {I18n.t('dashboard.averageScoreChapter')}
                <FilterDropdown
                    options={[I18n.t('dashboardElements.AllAudit'), I18n.t('dashboardElements.FirstAudit'), I18n.t('dashboardElements.ReAudit')]}
                    onApply={handleApplyFilters}
                    defaultSelected={[I18n.t('dashboardElements.AllAudit')]}
                    theme="dark"
                    icon="filter"
                    customClassName="widget-filter-menu"
                />
            </div>

            <div style={{ overflowY: "scroll", height: "625px", position: "relative" }}>

                {/* Sticky Header Section */}
                <div style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#fff", // important to avoid transparent background while scrolling
                    zIndex: 1,
                    padding: "10px 15px",
                    borderBottom: "1px solid #ccc",
                }}>
                    <p style={{
                        display: 'inline-block',
                        margin: 0,
                        marginRight: '3px',
                        border: "1px solid rgb(110 98 98)",
                        backgroundColor: "rgb(237 180 180)",
                        width: '103px',
                        paddingInline: '2px',
                        fontFamily: 'Arial, Helvetica, sans-serif',
                        fontSize: '13.5px',
                    }}>
                        {filterStatus}
                    </p>

                    <span style={{
                        marginRight: 15, fontFamily: 'Arial, Helvetica, sans-serif',
                        fontSize: '13.5px'
                    }}>
                        <span style={{
                            display: "inline-block",
                            width: 12,
                            height: 12,
                            backgroundColor: "#e50000",
                            marginRight: 5,
                            fontFamily: 'Arial, Helvetica, sans-serif',
                            fontSize: '13.5px'
                        }}></span>
                        {I18n.t('dashboardElements.CriticalScore')}
                    </span>
                    <span style={{
                        fontFamily: 'Arial, Helvetica, sans-serif',
                        fontSize: '13.5px'
                    }}>
                        <span style={{
                            display: "inline-block",
                            width: 12,
                            height: 12,
                            backgroundColor: "#28a745",
                            marginRight: 5
                        }}></span>
                        {I18n.t('dashboardElements.OverallScore')}
                    </span>
                </div>

                {/* Scrollable Chart Section */}
                {data && data?.length > 0 ? <div style={{ paddingTop: "10px" }}>
                    <ProgressBarChart isSecondProgressBar={true} data={filteredData || []} />
                </div> : <p style={{textAlign:"center", color:"#595d60", fontSize:"0.81rem"}}>{I18n.t('tabsDetails.noActionAvailable')}</p>}
            </div>

        </div>
    );
}
const mapStateToProps = state => {
    return {
        user: state.loginReducer,
        activityToolBox: state.activityReducer,
        cycleDataList: state.dashboardReducer.cycleDataList,
        toolboxByType: state.leftNavReducer
    };
};
export default withRouter(connect(mapStateToProps)(withTheme(AverageScoreChapter)));

